import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@kcftech/design-system';
import { Spinner } from 'components/spinner/Spinner';
import { useUserDateTimeFormat } from 'custom_hooks/useUserDateTimeFormat';
import { useEffect, useRef, useState } from 'react';

export type LastUpdatedProps = Readonly<{
    isLoading: boolean;
    reload: () => void;
}>;

export function LastUpdated({ isLoading, reload }: LastUpdatedProps) {
    const { formatTime } = useUserDateTimeFormat();
    const [lastUpdated, setLastUpdated] = useState(new Date());
    const wasLoadingRef = useRef(isLoading);

    useEffect(() => {
        // Update timestamp when loading changes from true to false
        if (wasLoadingRef.current && !isLoading) {
            setLastUpdated(new Date());
        }
        wasLoadingRef.current = isLoading;
    }, [isLoading]);

    const onReload = () => {
        reload();
        setLastUpdated(new Date());
    };

    return (
        <div className="flex-row align-center f-14">
            Updated {formatTime(lastUpdated)}
            <Button
                appearance="subtle"
                spacing="compact"
                onClick={onReload}
                disabled={isLoading}
            >
                {isLoading ? (
                    <Spinner size="1x" />
                ) : (
                    <FontAwesomeIcon icon={faArrowsRotate} />
                )}
            </Button>
        </div>
    );
}
